import React, { useEffect, useRef, useState } from "react";
import InstrumentDetailsContainer from "../InstrumentDetailsContainer/InstrumentDetailsContainer";
import taxlotsEmpty from "../../assets/images/svg/taxlotsEmpty.svg";
import nodataImage from "../../assets/images/svg/nodataImage.svg";
import Tabs from "../Tabs";
import { useLocation, useNavigate, useParams } from "react-router";
import { observer } from "mobx-react-lite";
import {
  breadCrumbArray2,
  commaSeperated,
  getDisplayDate,
  getSubAssetClasses,
  numWithUnitPerformance,
  showDashIfZero,
  showDataWithRupeeDashOrZero,
} from "../../utils/functions";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import AuthStore from "../../store/AuthStore";
import UserStore from "../../store/UserStore";
import PerformanceStore from "../../store/PerformanceStore";
import Header from "../Header/Header";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import ScrollDataTable from "../Table/ScrollDataTable";
import { defaultTransactionSortConfig } from "../../utils/constants";
import PageHeading from "../PageHeading/PageHeading";

const performanceDateCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="transaction_date_cell" style={{ minWidth: "423px" }}>
      {getDisplayDate(rowData.transaction_date)}
    </p>
  );
};

const performanceQtyCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {UserStore.isHybridNormalInstrument
        ? showDashIfZero(Number(rowData[key] || 0).toLocaleString("hi-IN"))
        : commaSeperated(rowData[key])}
    </p>
  );
};

const performancePriceCellRenderer = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {showDataWithRupeeDashOrZero(
        rowData?.rate,
        UserStore.isHybridNormalInstrument
      )}
    </p>
  );
};

const performanceTvaCellRenderer2 = (data, rowData, key, index) => {
  return (
    <p className="qty_cell" style={{ position: "relative" }}>
      {numWithUnitPerformance(rowData[key]?.value, rowData[key]?.value_type) ||
        "-"}
    </p>
  );
};

const performaceInfinityirrCellRenderer = (data, rowData, key, index) => {
  return (
    <p
      className={`irr_cell ${
        rowData.type === "Corpus Out" || rowData.type === "SOLD"
          ? "red_text"
          : ""
      }`}
    >
      {rowData?.type?.toUpperCase()}
    </p>
  );
};

const transactionColumns = [
  {
    label: "Transaction Date",
    key: "transaction_date",
    sortable: true,
    keyConfig: {
      clmName: "transaction_date",
      keysObj: { key1: "transaction_date" },
      keyLevel: 1,
      type: "date",
      dateFormat: "ymd",
    },
    cellRenderer: performanceDateCellRenderer,
  },

  {
    label: "Qty",
    key: "quantity",
    sortable: true,
    keyConfig: {
      clmName: "quantity",
      keysObj: { key1: "quantity" },
      keyLevel: 1,
      type: "numbers",
    },
    cellRenderer: performanceQtyCellRenderer,
  },
  {
    label: "Price",
    key: "rate",
    sortable: true,
    keyConfig: {
      clmName: "rate",
      keysObj: { key1: "rate" },
      keyLevel: 1,
      type: "numbers",
    },
    cellRenderer: performancePriceCellRenderer,
  },
  {
    label: "Transaction Value",
    key: "amount",
    sortable: true,
    keyConfig: {
      clmName: "amount",
      keysObj: { key1: "amount", key2: "actual_value" },
      keyLevel: 2,
      type: "numbers",
    },
    cellRenderer: performanceTvaCellRenderer2,
  },
  {
    label: "Transaction Type",
    key: "type",
    sortable: true,
    keyConfig: {
      clmName: "type",
      keysObj: { key1: "type" },
      keyLevel: 1,
      type: "strings",
    },
    cellRenderer: performaceInfinityirrCellRenderer,
  },
];

const EmptyState = (tab) => {
  return (
    <div className="tax_lots_empty flex is-justify-content-center is-align-items-center is-fullheight is-flex-direction-column">
      <div className="empty_state_img_wrapper">
        <img width="100%" src={taxlotsEmpty} alt="transaction icon" />
      </div>
      <div className="empty_state_txt">
        {`You do not have any ${
          tab === "taxLots" ? "Tax Lots" : "Transactions"
        } to Report`}
      </div>
    </div>
  );
};

const InstrumentsDetails = () => {
  const [selectedTab, setTab] = useState("transactions");

  const [sortingConfig, setSortingConfig] = useState({
    ...defaultTransactionSortConfig,
  });

  const transactionRef = useRef(null);
  const tablesRef = useRef(null);

  const navigate = useNavigate();
  const { id1 } = useParams();
  const location = useLocation();
  const [locationArr, setLocationArr] = useState([]);
  const {
    performanceRoute3,
    performanceRoute4,
    performanceRoute2,
    performanceRoute1,
  } = useParams();
  // const instrumentRef = useRef();
  const performanceRef3 = useRef();
  const routes = performanceRoute2?.split("_");
  let instrumentDetails = null;
  let instrumentWholeData = null;

  const userStoreHydrated = UserStore.isHydrated;

  if (performanceRoute3 !== undefined) {
    instrumentDetails = PerformanceStore.instrumentDetails[0];
    instrumentWholeData = UserStore.isHydrated
      ? { ...PerformanceStore.instrumentWholeData }
      : {};
  } else {
    instrumentDetails = UserStore?.instrumentDetails?.details;
    instrumentWholeData = UserStore.isHydrated
      ? { ...UserStore.instrumentDetails }
      : {};
  }

  const transactionData =
    UserStore.isHydrated &&
    PerformanceStore.isHydrated &&
    PerformanceStore?.instrumentWholeData?.transaction
      ? [...PerformanceStore?.instrumentWholeData?.transaction]
      : [];

  useEffect(() => {
    PerformanceStore.setCurrentLoader("fullScreen");
    AuthStore.updateLoadingFullScreen(true);
  }, []);

  useEffect(() => {}, [userStoreHydrated]);

  const setNavigation = (newArr, newArr2) => {
    if (performanceRoute1 !== "derivatives")
      setLocationArr(
        breadCrumbArray2(
          PerformanceStore.selectedAssetClass.id,
          newArr2,
          PerformanceStore?.secPageReturnData?.instrumentVehicle?.name ||
            getSubAssetClasses(routes?.[1] || ""),
          PerformanceStore?.instrumentDetails?.[0]?.instrument?.name
        ).slice(1)
      );
    else
      setLocationArr(
        breadCrumbArray2(
          PerformanceStore.selectedAssetClass.id,
          newArr,
          performanceRoute2 === "1" ? "Futures " : "Options "
        ).slice(1)
      );

    if (performanceRoute4 !== undefined) {
      setLocationArr((prevState) => {
        prevState.pop();
        return prevState;
      });
    }
  };

  performanceRef3.current = setNavigation;

  useEffect(() => {
    if (UserStore.isHydrated && PerformanceStore.isHydrated) {
      if (!PerformanceStore.subTabs.length) {
        navigate("/performance/overall performace");
      } else {
        const route1 = performanceRoute2?.split("_");
        PerformanceStore.onThirdPage({
          assetClassId: route1[0],
          subAssetClassId: route1[1],
          measureId: performanceRoute3,
          folioId: performanceRoute4,
        });
        PerformanceStore.setIsClassIdChecked(true, "setting true");
        PerformanceStore.setPerformanceApiCalled(true);
      }
    }
  }, [UserStore.isHydrated, PerformanceStore.isHydrated]);

  useEffect(() => {
    const newArr = location.pathname.split("/");
    const newArr2 = [...newArr];
    performanceRef3.current(newArr, newArr2);
  }, [PerformanceStore?.instrumentDetails]);

  // const handleClickFun = (index) => {};

  return (
    <>
      {AuthStore.isLoadingFullScreen ||
      !UserStore.isHydrated ||
      !PerformanceStore.isHydrated ? (
        <LoadingScreen />
      ) : (
        <>
          <Header type="performance" />
          <div className="performance_instrument_details">
            <BreadCrumb
              locationArr={locationArr}
              // clickFunction={(index) => handleClickFun(index)}
              parentName={"performance"}
            />

            <div className="instru_det_outside">
              <PageHeading
                headingClass="instru_det_title"
                headingText="Instrument Details"
              />
              <div className="instru_det_cont_main">
                {!!instrumentDetails && !!instrumentWholeData ? (
                  <InstrumentDetailsContainer
                    storeInstrumentData={instrumentWholeData}
                    data={instrumentDetails}
                    id1={id1}
                    addDash={UserStore.isHybridNormalInstrument ? true : false}
                    isInterest={
                      UserStore.instrumentDetails?.details?.instrument
                        ?.isInterest
                    }
                    unitBased={
                      UserStore?.instrumentDetails?.details?.instrument
                        ?.isUnitBased
                    }
                  />
                ) : (
                  <div className="details_wrapper">
                    <img src={nodataImage} alt="NoData" />
                    <p>No data found</p>
                  </div>
                )}
              </div>

              <div
                className={
                  UserStore.isHybridNormalInstrument
                    ? "infinity_holdings_bg margin_for_instrument flex_class"
                    : "margin_for_instrument flex_class"
                }
              >
                <div className="tabsNTableWrapper performancePage">
                  <div className="tabs_wrapper">
                    <Tabs
                      onSelect={(value) => {
                        setTab(value);
                      }}
                      tabs={
                        location?.state?.from === "performance" ||
                        UserStore?.isInfinity === "1" ||
                        !UserStore?.instrumentDetails?.details?.instrument
                          ?.isUnitBased
                          ? [
                              {
                                label: "Transactions",
                                value: "transactions",
                              },
                            ]
                          : [
                              {
                                label: "Transactions",
                                value: "transactions",
                              },
                              {
                                label: "Tax Lots",
                                value: "taxLots",
                              },
                            ]
                      }
                    />
                  </div>

                  {selectedTab === "transactions" &&
                    !!instrumentWholeData?.transaction && (
                      <div
                        ref={tablesRef}
                        className={
                          UserStore.isHybridNormalInstrument
                            ? "infinity_table_wrapper"
                            : "performance_table_wrapper"
                        }
                        onScroll={(e) => {
                          transactionRef.current.handleScrollStart(e, "");
                        }}
                      >
                        <ScrollDataTable
                          ref={transactionRef}
                          tableData={transactionData}
                          columns={transactionColumns}
                          tableClass="equity_summary_table_transac performance"
                          EmptyState={() => EmptyState(selectedTab)}
                          sortingConfig={sortingConfig}
                          setSortingConfig={(data) => {
                            tablesRef.current.scrollTop = 0;
                            setSortingConfig(data);
                          }}
                        />
                      </div>
                    )}
                  {selectedTab === "taxLots" &&
                    !!instrumentWholeData?.taxLots && (
                      <div
                        className={
                          UserStore.isHybridNormalInstrument
                            ? "infinity_table_wrapper"
                            : ""
                        }
                      >
                        {/* if taxlots are needed to show , then display a table ui here */}
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default observer(InstrumentsDetails);
